import './App.css';
import Layout from "./components/Layout/Layout";
import "./i18n";
import { Navigate, HashRouter as Router, Routes, Route } from 'react-router-dom';
import General from './components/Pages/General';
import Teaching from './components/Pages/Positions/Teaching';
import Research from './components/Pages/Positions/Research';
import Vacant from './components/Pages/Positions/Vacant';
import Homologate from './components/Pages/Homologate';


function App() {

  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="doctorados/" element={<General />}></Route>
            <Route path="doctorados/teaching-assistant" element={<Teaching />}></Route>
            <Route path="doctorados/research-assistant" element={<Research />}></Route>
            <Route path="doctorados/homologate" element={<Homologate />}></Route>
            <Route exact path="doctorados/vacant/:id_vacant" element={<Vacant />}></Route>
            <Route
                path="*"
                element={<Navigate to="doctorados/" />}
            />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
